<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>
                <!-- <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Other ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getCategoryPI"
                      :key="item.value"
                      :value="item.value"
                      >{{ item.text }}</a-select-option
                    >
                  </a-select>
                </div> -->
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Termin Release List"
        createLink="terminReleaseCreateMar"
        manifestLink="terminReleaseManifestMar"
        editLink="terminReleaseEditMar"
        :dataList="searching"
        :isTransactional="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "listTerminRelease",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      kategori: undefined,
      searchDate: null,
      search: "",
      status: undefined,
      matauang: undefined,
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
      "getAllMataUang",
      "getCategoryPI",
    ]),
    searching() {
      var self = this;
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getDefaultDateFormat);
        output = output.filter(
          (obj) =>
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) === filter
        );
      }

      // if (this.kategori) {
      //   output = output.filter((item) => {
      //     return item.used_for == self.kategori;
      //   });
      // }

      // if (this.matauang) {
      //   output = output.filter((item) => {
      //     return item.mata_uang === self.matauang;
      //   });
      // }

      // if (this.status) {
      //   if (this.status=="closed"){
      //     output = output.filter(
      //       (obj) =>
      //         obj.closeStatus && obj.closeStatus.toLowerCase().indexOf("close") >= 0
      //     );
      //   } else if(this.status=="cancelled"){
      //     output = output.filter(
      //       (obj) =>
      //         obj.cancelStatus && obj.cancelStatus.toLowerCase().indexOf("canceled") >= 0
      //     );
      //   }else{
      //     output = output.filter(
      //       (obj) =>
      //         obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0 &&
      //         !(obj.closeStatus && obj.closeStatus.toLowerCase().indexOf("close") >= 0) &&
      //         !(obj.cancelStatus && obj.cancelStatus.toLowerCase().indexOf("canceled") >= 0)
      //     );
      //   }
      // }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "termin",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.basedList = response.data.data;

          response.data.data.forEach((data) => {
            this.dataList.push({
              // islistPPrevised: !((data.cancel_sts== 1 || data.close_sts=="1") || data.status=="Rejected") && !(data.ispibkkuploaded && data.ispibkkuploaded=='1'),
              title: data.no_trans,
              subtitle: { deskripsi: (data.description_contract ? data.description_contract : '-') },
              // timeline: JSON.parse(data.status_app),
              // unread: data.unread == "1" ? true : false,
              subdesc: [
                data.kode_contract ? data.kode_contract : "-",
                (data.tgl_transaksi ? data.tgl_transaksi : "-")+" | "+
                data.tlc_create ? data.tlc_create : "-",
                data.total_value ? this.formatCurrency("IDR",data.total_value) : "-",
              ],
              id: data.id_termin_release,
              // status: data.edit_sts=="1" ? "Revised" : null,
              status: data.edit_sts=="enabled" ? "Revised" : "-",
              cancelStatus: data.status,
              canceled_Status: data.cancel_sts == "enabled" ? "unCanceled" : "Canceled",
              mata_uang: "IDR",
              tgl_buat: data.tgl_transaksi,
              searchQ:
                data.no_trans +
                " " +
                (data.description_contract ? data.description_contract :'') +
                " " +
                data.kode_contract +
                " " +
                data.total_pemakaian,
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "termin/cancel",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          id_termin_release: item.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.fetchData();
          this.searching;
          this.$router.go(0);

        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          if(responses.status==false && responses.message){
            this.displayMessageValue("error-other", responses.message);
          }else{
            this.displayMessageValue("error", responses);
          }
        });
    },
  },
};
</script>

<style>
</style>